import styled from 'styled-components';
import { InputText } from 'ui/inputs';
import { spacing, heading2, heading4 } from 'ui/theme';

export const FormRow = styled.div`
  display: flex;
`;

export const StyledInput = styled(InputText)`
  margin-right: ${spacing.base};
`;

export const StyledTitle = styled.div`
  ${heading2};
`;

export const StyledFormHeader = styled.div`
  ${heading4};
  padding-top: ${spacing.plusHalf};
  padding-bottom: ${spacing.base};
`;
